import { AppMetaDataSliceActions } from "@lxp-app/store/slices/appMetaDataSlice";

export const requestFullScreen = (dispatch: any) => {
  const element = document.documentElement;
  if (element.requestFullscreen) {
    element.requestFullscreen();
    if (AppMetaDataSliceActions) {
      dispatch(AppMetaDataSliceActions.setViewHeader(false));
      dispatch(AppMetaDataSliceActions.setViewBreadcrumb(false));
      dispatch(AppMetaDataSliceActions.setViewFooter(false));
    }
  }
};

export const exitFullScreen = (dispatch: any) => {
  if (document && document.exitFullscreen) {
    document.exitFullscreen();
    if (AppMetaDataSliceActions) {
      dispatch(AppMetaDataSliceActions.setViewHeader(true));
      dispatch(AppMetaDataSliceActions.setViewFooter(true));
    }
  }
};
